import type { UserSummary } from '@/api/types'

const TOKEN_KEY = 'remote-ai-token'
const USER_KEY = 'remote-ai-user'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function getUser(): UserSummary | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (
      typeof parsed?.id === 'number' &&
      typeof parsed?.email === 'string' &&
      (parsed?.role === 'admin' || parsed?.role === 'user')
    ) {
      return parsed as UserSummary
    }
  } catch {
    // ignore
  }
  return null
}

export function saveSession(token: string, user: UserSummary): void {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}
